import styled from "@emotion/styled"
import { Typography, TypographyProps } from "@mui/material"
import * as api from "api"
import { CommonForm } from "common/forms"
import { getPrivacyPolicyLink } from "common/NavigationLinks"
import { Field } from "formik"
import { TextField } from "formik-mui"
import Link from "next/link"
import { useEffect, useState } from "react"
import Shared from "theme/shared"
import { ServiceCenterContactStatus } from "../dialogs/ServiceCenterContactDialog"
import schema, { initialFormState, MAX_CONTENT } from "./ContactFormSchema"

const Styled = {
  Field: styled(Field)``,
  FormContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  ContentWrap: styled.div`
    position: relative;
  `,
  Counter: styled.span`
    position: absolute;
    left: 5px;
    bottom: -1px;
    font-size: 0.75rem;
  `,
  SendButton: styled(Shared.Button)`
    height: 35px;
    font-size: 14px;
    width: auto;
    width: 150px;
    white-space: nowrap;
    margin-top: 16px;
  `,
  PrivacyPolicyCaption: styled((props: TypographyProps) => (
    <Typography variant="body2" {...props} />
  ))``,
  Link: styled(Link)`
    text-decoration: underline;
  `,
}

type ContactFormProps = {
  onChange: (status: ServiceCenterContactStatus) => void
  ServiceCenter: api.SingleServiceCenter & api.ServiceCenter
}

const ContactForm = ({ onChange, ServiceCenter }: ContactFormProps) => {
  const [privacyPolicyLink, setPrivacyPolicyLink] = useState<string>("")

  useEffect(() => {
    getPrivacyPolicyLink().then((link) => {
      setPrivacyPolicyLink(link)
    })
  }, [])
  return (
    <CommonForm
      validationSchema={schema}
      initialValues={initialFormState}
      onSubmit={async (values) => {
        try {
          const { data } = await api.postServiceCenterContact({
            name: values.fullName,
            mobilePhone: values.phone,
            serviceCenterId: ServiceCenter.id,
            applicationType: "Contact",
            rishui: values.licenceNumber,
            email: ServiceCenter.email,
            customerEmail: values.emailAddress,
            content: values.content,
            treatmentDate: null,
            treatmentTime: null,
            treatmentType: "Default",
          })
          onChange(data.body ? "success" : "failure")
        } catch (error) {
          console.error(error)
          onChange("failure")
        }
      }}
      render={({ values }) => (
        <Styled.FormContainer>
          <Field
            name="fullName"
            component={TextField}
            label="שם מלא"
            autoComplete="name"
            id="name"
            required
            helperText=" " // prevent a "jump" when an error appears
          />
          <Field
            name="phone"
            id="phone"
            component={TextField}
            type="tel"
            label="מספר נייד"
            autoComplete="tel-national"
            required
            helperText=" " // prevent a "jump" when an error appears
            inputProps={{ maxLength: 11 }}
          />
          <Field
            name="emailAddress"
            id="emailAddress"
            component={TextField}
            type="email"
            label='דוא"ל'
            autoComplete="email"
            required
            helperText=" " // prevent a "jump" when an error appears
            inputProps={{ style: { direction: "ltr" } }}
          />
          <Field
            name="licenceNumber"
            id="licenceNumber"
            component={TextField}
            label="לוחית רישוי"
            type="tel"
            required
            placeholder="000-00-000"
            helperText=" " // prevent a "jump" when an error appears
            inputProps={{ maxLength: 10 }}
          />
          <Styled.ContentWrap>
            <Field
              name="content"
              component={TextField}
              label="תוכן הפניה"
              id="name"
              required
              multiline
              rows={5}
              helperText=" " // prevent a "jump" when an error appears
              inputProps={{ maxLength: MAX_CONTENT }}
            />
            <Styled.Counter>
              {values.content.length}/{MAX_CONTENT}
            </Styled.Counter>
          </Styled.ContentWrap>
          <Styled.PrivacyPolicyCaption>
            מסירת הפרטים מהווה הסכמה{" "}
            <Styled.Link target="_blank" href={privacyPolicyLink}>
              למדיניות הפרטיות
            </Styled.Link>{" "}
            של דלק מוטורס
          </Styled.PrivacyPolicyCaption>
          {/* TODO: Use LoadingButton */}
          <Styled.SendButton variant="contained" type="submit">
            שליחת פרטים
          </Styled.SendButton>
        </Styled.FormContainer>
      )}
    />
  )
}

export default ContactForm
